import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { theme } from '@/theme';

const getStepperBackgroundColor = (
  isActive: boolean,
  isCompleted: boolean,
  isDisabled: boolean,
) => {
  if (isDisabled) {
    return theme.colors.primaryDisabled;
  }
  if (isActive) {
    return 'transparent';
  }
  if (isCompleted) {
    return theme.colors.primary;
  }
  return theme.colors.mediumGrey;
};

export const Wrapper = styled(Box)`
  position: relative;
  display: flex;
  align-items: center;
`;

export const StepContainer = styled(Flex)`
  width: 100%;

  &:last-child {
    width: auto;
  }
`;

export const StepBadge = styled(Box)<{
  $isActive: boolean;
  $isCompleted: boolean;
  $isDisabled: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  ${({
    $isActive,
    $isCompleted,
    $isDisabled,
    theme: {
      colors,
      components: { stepper },
      space,
    },
  }) => css`
    cursor: ${$isDisabled || !$isCompleted ? 'not-allowed' : 'pointer'};
    margin: 0 ${space.s050};
    width: ${stepper.badge.width};
    height: ${stepper.badge.height};
    border-radius: ${stepper.badge.borderRadius};
    border: ${stepper.badge.borderWidth} solid
      ${$isDisabled
        ? colors.primaryDisabled
        : $isActive || $isCompleted
          ? colors.primary
          : colors.mediumGrey};
    background-color: ${getStepperBackgroundColor(
      $isActive,
      $isCompleted,
      $isDisabled,
    )};
  `}
`;

export const CheckMark = styled(Box)`
  ${({ theme: { colors } }) => css`
    border: solid ${colors.white};
  `};
  width: 19px;
  height: 8px;
  transform: rotate(-45deg);
  border-width: 0 0 3px 3px;
`;

export const LineContainer = styled(Box)`
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
`;

export const StepLine = styled(Box)<{ isCompleted: boolean }>`
  width: 100%;
  height: 4px;

  ${({ isCompleted, theme: { colors } }) => css`
    background: ${isCompleted ? colors.primary : colors.mediumGrey};
  `}
`;
